type RoutinesTranslator = Application['modules']['riskManagement']['controller']['helpers']['routinesTranslations'];

export function getRoutinesTranslator(): RoutinesTranslator {
  const translator = Application?.modules?.riskManagement?.controller?.helpers?.routinesTranslations;
  if (translator === undefined || translator === null) {
    throw new Error('Unable to load Risk Management translations.');
  }

  return translator;
}
